export const useProductionEnvironment = () => {
  return { isProd: process.env.REACT_APP_ENV === 'production' };
};
